module.exports = __webpack_public_path__ + "static/media/externalLinkIcon.4767aeff.svg";